import { render, staticRenderFns } from "./VendList.vue?vue&type=template&id=64b2e4f2&scoped=true&"
import script from "./VendList.vue?vue&type=script&lang=js&"
export * from "./VendList.vue?vue&type=script&lang=js&"
import style0 from "./VendList.vue?vue&type=style&index=0&id=64b2e4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b2e4f2",
  null
  
)

export default component.exports